import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import Navbar from './components/Navbar';
import Home from './components/Home';
import TeamRegistration from './components/TeamRegistration';
import AccountDetails from './components/AccountDetails';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import SearchClubs from './components/SearchClubs';
import TermsPage from './components/TermsPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

import SportsClubMatches from './components/SportsClubMatches';
import SportsClubReceivedMatches from './components/SportsClubReceivedMatches';
import UserManagement from './components/UserManagement';
import TeamManagement from './components/TeamManagement';
import Settings from './components/Settings';
import PreseasonGamesSummary from './components/PreseasonGamesSummary';
import PreseasonGameInvitationLanding from './components/PreseasonGameInvitationLanding';
import Notifications from './components/Notifications';
import Payments from './components/Payments';
import Management from './components/Management';
import PreseasonGamesSummaryReport from './components/PreseasonGamesSummaryReport';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentError from './components/PaymentError';
import Results from './components/Results';
import AdminAccess from './components/AdminAccess';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
        <Router>
          <NotificationProvider>
          <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tournament/:id/register" element={<TeamRegistration />} />
            <Route path="/account" element={<ProtectedRoute><AccountDetails /></ProtectedRoute>} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/search-clubs" element={<ProtectedRoute><SearchClubs /></ProtectedRoute>} />

            <Route path="/sports-club-matches" element={<ProtectedRoute allowedRoles={['COACH', 'SPORTS_CLUB']}><SportsClubMatches /></ProtectedRoute>} />
            <Route path="/sports-club-received-matches" element={<ProtectedRoute allowedRoles={['COACH', 'SPORTS_CLUB']}><SportsClubReceivedMatches /></ProtectedRoute>} />
            <Route path="/management" element={<ProtectedRoute allowedRoles={['COACH', 'SPORTS_CLUB']}><Management /></ProtectedRoute>} />
            <Route path="/user-management" element={<Navigate to="/management" replace />} />
            <Route path="/team-management" element={<Navigate to="/management" replace />} />
            <Route path="/settings" element={<ProtectedRoute allowedRoles={['COACH', 'SPORTS_CLUB']}><Settings /></ProtectedRoute>} />
            <Route path="/preseason-games-plans" element={<ProtectedRoute allowedRoles={['COACH', 'SPORTS_CLUB']}><PreseasonGamesSummary /></ProtectedRoute>} />
            <Route path="/preseason-games-summary" element={<ProtectedRoute allowedRoles={['COACH', 'SPORTS_CLUB']}><PreseasonGamesSummaryReport /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/payments" element={<Navigate to="/management" replace />} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/payment/error" element={<ProtectedRoute><PaymentError /></ProtectedRoute>} />
            <Route path="/admin/access" element={<ProtectedRoute><AdminAccess /></ProtectedRoute>} />
            <Route path="/results" element={<Results />} />
            <Route path="/preseason-game-invitations/:token" element={<PreseasonGameInvitationLanding />} />
            <Route path="/regulamin" element={<TermsPage />} />
            <Route path="/polityka-prywatnosci" element={<PrivacyPolicyPage />} />
          </Routes>
          <Footer />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </NotificationProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
